var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDinersClub = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  className: "icon icon--dinersclub",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.27 7.414c-2.528.001-4.576 2.05-4.577 4.578 0 2.528 2.049 4.576 4.577 4.577 2.528 0 4.577-2.049 4.578-4.577-.001-2.529-2.05-4.578-4.578-4.578zm-1.039 7.284c-1.088-.418-1.859-1.471-1.862-2.707.003-1.236.774-2.289 1.862-2.708v5.415zm2.077.001v-5.416c1.089.417 1.861 1.472 1.864 2.708-.002 1.237-.775 2.29-1.864 2.708zm9.692-10.699h-20c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h20c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-9.444 13h-1.296c-2.767.013-5.043-2.228-5.043-4.956-.001-2.982 2.275-5.044 5.042-5.044h1.296c2.734 0 5.229 2.061 5.229 5.043 0 2.728-2.495 4.957-5.228 4.957z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDinersClub, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconDinersClub.b5852962.svg";
export { ForwardRef as ReactComponent };